import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { PartialFiltersMatch } from 'components/HotelCard/PartialFiltersMatch/PartialFiltersMatch';
import { HotelCardContext } from 'components/HotelCardContext';
import { LocationDetails } from 'components/HotelCardLocationDetails';
import { VacationRentalDetails } from 'components/VacationRentalDetails';
import { getDistanceFromTarget, getHotel, State } from 'modules/sapiSearch/selectors';
import { getListOfValues } from 'modules/search/selectors';
import { getRankedAvailableFacilities } from 'utils/facilities';
import { Box } from '@daedalus/atlas/helpers/Box';
import { StarRating } from '@daedalus/atlas/StarRating';
import { ReviewRating } from '@daedalus/shared/src/search/ReviewRating';
import { PropertySummaryLoading } from './PropertySummaryLoading';
const HotelName = /*#__PURE__*/styled('div')({
  name: "HotelName",
  class: "h16g5496",
  propsAsIs: false
});
export const PropertySummary: React.FC = () => {
  const {
    hotelId,
    hotelDetailsIsOpenOnLanding,
    isAnchor
  } = useContext(HotelCardContext);
  const hotel = useSelector((state: State) => getHotel(state, hotelId));
  const distanceFromTarget = useSelector((state: State) => getDistanceFromTarget(state, hotelId));
  const listOfValues = useSelector(getListOfValues);
  const rankedFacilities = getRankedAvailableFacilities(hotel?.facilities, listOfValues);

  // Showing skeleton
  if (!hotel || !hotelId) return <PropertySummaryLoading />;
  return <Box display="flex" flexDirection="column" height="100%" alignContent="space-between">
      <div data-id="StarRating">
        <StarRating size="xs" rating={hotel.starRating} />
      </div>
      <HotelName data-id="HotelName">{hotel.hotelName}</HotelName>
      <LocationDetails placeName={hotel.placeDisplayName} distance={distanceFromTarget} />

      <Box display="inline-block" paddingTop="s300">
        <ReviewRating rating={hotel?.guestRating.overall} totalRatingCount={hotel.reviewCount} hotelId={hotel.objectID} />
      </Box>

      {!isAnchor && <Box paddingTop="s300" paddingBottom="s300" paddingLeft="s000" paddingRight="s000">
          <PartialFiltersMatch hasBasicPropertyDetails={hotelDetailsIsOpenOnLanding && isAnchor} />
        </Box>}

      {hotelDetailsIsOpenOnLanding && isAnchor && <Box paddingTop="s400" paddingBottom="s400" paddingLeft="s000" paddingRight="s000">
          <VacationRentalDetails showVrDetails={hotel?.isVr} vrDetails={hotel?.vrDetails || {}} rankedFacilities={rankedFacilities} />
        </Box>}
    </Box>;
};

require("./PropertySummary.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PropertySummary.tsx");